import ServiceSection from "modules/components/ServiceSection";
import HideIf from "util/HideIf";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import ShowMoreAndLess from "modules/product/showMoreAndLess/ShowMoreAndLessContainer";
import isHighTrafficPage from "util/helper/isHighTrafficPage";
import { useRouter } from "next/router";
import isHomePage from "util/helper/isHomePage";
import ViewAll from "component/design-system/ViewAll";
import { useTranslation } from "next-i18next";
import SponsoredBrands from "../sponsored-brands/SponsoredBrands";
import Content from "../car-parts/Content";
import styles from "./homeBrandsSectionContainer.module.scss";

export default function HomeBrandsSectionContainer(props: any) {
  const router = useRouter();
  const { pathname } = router;
  const { t } = useTranslation("home");
  const { highTrafficPageData, sponsoredBrandsV2 } = props;

  return (
    <HideIf show={(highTrafficPageData?.Manufacturers.H2 && (highTrafficPageData?.Manufacturers.content || highTrafficPageData?.Manufacturers.article)) || isHomePage(pathname)}>
      <ServiceSection className={styles.service_section_padding}>
        <div className="d-flex" style={{ position: "relative" }}>
          <PAText
            bold
            component="h2"
            fontSize={FONT_SIZE[5]}
            className={styles.title}
          >
            {highTrafficPageData?.Manufacturers.H2 || t("oem_aftermarket_manufacturers")}
          </PAText>
          <div className={styles.all_manufacturer_view_all}>
            <ViewAll href="/all-manufacturers" title="Explore a Wide Range of Vehicle Parts Manufacturers" />
          </div>
        </div>
        <div style={{ width: "100%" }}>

          <ShowMoreAndLess
            contentDescription={(
              <div
                className={`${styles.manufacturer_parts_h2} ${styles.sub_content} m-t-0 m-b-15`}
              >
                <HideIf show={!isHighTrafficPage(router)}>
                  <Content content={t("oem_aftermarket_manufacturers_description")} />
                </HideIf>
                <HideIf show={isHighTrafficPage(router)}>
                  <Content content={highTrafficPageData?.Manufacturers.content} article={highTrafficPageData?.Manufacturers.article} />
                </HideIf>

              </div>
            )}
            defaultHeight={5}
            style={{ maxHeight: "calc(5 * var(--safari-root-font, 10px))" }}
            className={styles.show_more_less_container}
          />
        </div>

        <div className={`${styles.section} m-t-0 p-b-5 p-t-5`}>
          <SponsoredBrands brands={sponsoredBrandsV2} />
        </div>
      </ServiceSection>
    </HideIf>

  );
}
